// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"4b0def35","264":"93a25701","480":"78a60a1e","638":"acfe7dfa","738":"0d8cbaa4"}[chunkId] + ".chunk.js";
};